import { NumericFormat } from "react-number-format"

import Style from "@/components/MultiFinshProductBundle/styles/BundleInfoUI.module.scss"

const BundleInfoUI = props => {
  const {
    pdpDetails = {},
    staticTexts = {},
    finalProductPrice = "",
    isPriceLoading = true,
    config = {},
  } = props || {}

  const { internationalization: { currencySign = "$" } = {} } = config

  const { name = "", desc = "", sku = "" } = pdpDetails || {}
  const productName = name || desc

  return (
    <div className={Style.BundleInfo}>
      <div className="title-desc">
        {productName ? (
          <>
            <h1 className="title">{productName}</h1>
            {name && desc ? <p className="description">{desc}</p> : null}
          </>
        ) : (
          <div className="title-desc">
            <p className="shimmer-loading__para shimmer width-170"></p>

            <p className="shimmer-loading__para shimmer width-170 description"></p>
          </div>
        )}
      </div>
      <p className="skuid">{sku}</p>
      {!isPriceLoading && finalProductPrice ? (
        <p
          className="price"
          aria-label={`${staticTexts?.currentPriceAriaLabel} ${currencySign}${finalProductPrice}`}
        >
          <NumericFormat
            value={finalProductPrice}
            displayType="text"
            thousandSeparator={true}
            prefix={currencySign}
            decimalScale={2}
            fixedDecimalScale={true}
          />
        </p>
      ) : (
        <p className="shimmer-loading__para shimmer width-170 price-spinner" />
      )}
    </div>
  )
}

export default BundleInfoUI
